import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { RiShareForwardFill, RiCloseFill } from 'react-icons/ri';
import { graphql, useStaticQuery } from 'gatsby';
import { ReactComponent as GlobeLogo } from '@bostonglobe/logos/logos/bglobe/bglobe-logo-black.svg';
import { ReactComponent as GlobeBug } from '@bostonglobe/logos/logos/bglobe/bglobe-bug-black.svg';
import { ReactComponent as Mail } from '~assets/images/mail.svg';
import { ReactComponent as Facebook } from '~assets/images/facebook.svg';
import { ReactComponent as Twitter } from '~assets/images/twitter.svg';
import generateMailtoLink from '~lib/generateMailtoLink';
import generateFacebookLink from '~lib/generateFacebookLink';
import generateTwitterLink from '~lib/generateTwitterLink';

import '~styles/modules/header.scss';
import '~styles/modules/logo.scss';

const MobileShareButton = styled.button`
    opacity: 0.75;
    padding: 0;
    border: none;
    background-color: initial;
    font-size: 1.5rem;
    margin-right: -5px;
    transition: .2s ease all;
    position: relative;
    top: 0.25rem;
    display: none;
    @media(max-width: 600px) {
      display: inline-block;
    }
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
`;

const HeaderShareTray = styled.div`
  display: block;
  transition: all 0.5s ease-out;
  @media (max-width: 600px) {
    transform: translate(85%, -5px);
    &.visible {
      transform: translate(0, -5px);
    }
  }
`;

const Header = () => {
  const data = useStaticQuery(graphql`
      query SiteHeaderQuery {
          site {
              siteMetadata {
                  title
                  siteName
                  sectionName
              }
          }
      }
  `);
  const [pageUrl, setPageUrl] = React.useState('');
  React.useEffect(
    () => {
      setPageUrl(window.location.href);
    },
    [],
  );

  const [socialDisplay, setSocialDisplay] = useState(false);

  const displaySocial = useCallback(() => {
    setSocialDisplay(!socialDisplay);
  }, [socialDisplay]);

  const socialSettings = {
    url: pageUrl,
    text: data.site.siteMetadata.title,
  };

  return (
    <header className="header">
      <div className="header__inner">
        <div className="header__logo">
          <a href="http://www.bostonglobe.com">
            <GlobeLogo
              className="logo--lg"
              viewBox="0 0 500 67"
              width={140}
              height={18}
            />
            <GlobeBug
              className="logo--sm"
              viewBox="0 0 500 500"
              width={15}
              height={18}
            />
          </a>
        </div>
        <nav className="header__title benton-n6">
          {data.site.siteMetadata.sectionName}
        </nav>
        <div className="header__share">
          <HeaderShareTray className={socialDisplay ? 'visible' : ''}>
            <MobileShareButton type="button" onClick={() => displaySocial()}>
              {(socialDisplay && <RiCloseFill />)}
              {(!socialDisplay && <RiShareForwardFill />)}
            </MobileShareButton>
            <a
              href={generateMailtoLink(socialSettings)}
              target="_blank"
              rel="noreferrer"
              className="header__share-button"
            >
              <Mail />
            </a>
            <a
              href={generateFacebookLink(socialSettings)}
              target="_blank"
              rel="noreferrer"
              className="header__share-button"
            >
              <Facebook />
            </a>
            <a
              href={generateTwitterLink(socialSettings)}
              target="_blank"
              rel="noreferrer"
              className="header__share-button"
            >
              <Twitter />
            </a>
          </HeaderShareTray>

        </div>
      </div>
    </header>
  );
};

export default Header;
